import { useNotificationsBootstrap } from "@hooks/useNotificationsBootstrap";

export const NotificationsBootstrap = () => {
  useNotificationsBootstrap();
  return null;
};
